import moment from 'moment';

import { storeInCache,getFromCache } from '../../shared/localData/localStorage';
export default {
  install(app) {
    app.config.globalProperties.$moment = moment;
    app.config.globalProperties.$storeInCache = storeInCache;
    app.config.globalProperties.$getFromCache = getFromCache;
    app.config.globalProperties.$formatNumber = function (number) {
      return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    };
  },
};